<template>
  <div class="adviceBox">
    <div class="adviceBox1">
      <el-tabs style="height:100%" v-model="activeName" class="demo-tabs" @tab-click="handleClick">
        <el-tab-pane label="入库" name="1">
          <RKJL ref="RKJLRef" :dictCatalogType="'160000000'"></RKJL>
        </el-tab-pane>
        <el-tab-pane label="出库" name="2">
          <my-CKJL ref="CKJLRef" :dictCatalogType="'160000000'"></my-CKJL>
        </el-tab-pane>
        <el-tab-pane label="库存" name="5">
          <DQKC ref="DQKCRef" :dictCatalogType="'160000000'"></DQKC>
        </el-tab-pane>
        <el-tab-pane label="退库" name="7">
          <myTKJL ref="TKJLRef" :dictCatalogType="'160000000'"></myTKJL>
        </el-tab-pane>
        <el-tab-pane label="盘点" name="6">
          <PDCom ref="PDComRef" :dictCatalogType="'160000000'"></PDCom>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>

  import { toRefs, reactive, onMounted, ref, getCurrentInstance, nextTick } from 'vue'
  import { Search, ArrowRightBold, ArrowLeftBold } from '@element-plus/icons-vue'
  import service from '@/utils/request'
  import BaseDialog from '@/components/Dialog/index.vue'
  import { gitDictList, TimeYear, downLoadXlsx, TimestampToTime } from '@/utils/tool'
  import { ElMessage, ElMessageBox } from 'element-plus'
  import RKJL from '@/components/KCManager/rk/RKJL'
  import myTKJL from '@/components/KCManager/tk/TKJL.vue'
  import myCKJL from '@/components/KCManager/ck/ckCom.vue'
  import DQKC from '@/components/KCManager/DQKC'
  import PDCom from '@/components/KCManager/pd/PDCom.vue'
  export default {
    components: {
      BaseDialog,
      myTKJL,
      myCKJL,
      ArrowRightBold,
      RKJL,
      DQKC,
      PDCom
    },
    setup() {
      let { proxy } = getCurrentInstance()
      const state = reactive({
        dict_type: '',
        activeName: '1',
        activeName1: '1',
        activeName2: '1',
        activeName3: '1',
        tableHei: 0,
        THJLRef: null,
        YPCXRef: null,
        HZSYRef: null,
        TKJLRef: null,
        CKJLRef: null,
        KCPDRef: null,
        RKJLRef: null,
        istable: true,
        tableRef: null,
      })
      onMounted(() => {
        state.istable = false
        nextTick(() => {
          console.log(state.tableRef.clientHeight)
          state.tableHei = state.tableRef.clientHeight
          state.istable = true
        })
        initData()
      })
      // tabs标签页点击事件
      const handleClick = (e) => {
        state.activeName = JSON.parse(JSON.stringify(e.props.name))
        if (state.activeName == '1') {
          state.RKJLRef.gettobody()
        } else if (state.activeName == '2') {
          nextTick(() => {
            state.CKJLRef.initData()
          })
        } else if (state.activeName == '3') {
          nextTick(() => {
            state.YPCXRef.tobody()
          })
        } else if (state.activeName == '4') {
          nextTick(() => {
            state.KCPDRef.tobody()
          })
        } else if (state.activeName == '5') {
          nextTick(() => {
            proxy.$refs.DQKCRef.tobody()
          })
        }else if(state.activeName == '6'){
          nextTick(()=>{
            proxy.$refs.PDComRef.tobody()
          })
        }else if(state.activeName == '7'){
          nextTick(()=>{
            proxy.$refs.TKJLRef.getSuire()
            proxy.$refs.TKJLRef.tobody()
          })
        }
      }
      //入库管理tab
      const handleClick1 = (e) => {
        state.activeName1 = JSON.parse(JSON.stringify(e.props.name))
        if (state.activeName1 == '1') {
          state.RKJLRef.gettobody()
        } else {
          nextTick(() => {
            state.CKJLRef.tobody()
          })
        }
      }
      //出库管理tab
      const handleClick2 = (e) => {
        state.activeName2 = JSON.parse(JSON.stringify(e.props.name))
        if (state.activeName2 == '2') {
          nextTick(() => {
            state.TKJLRef.tobody()
          })
        } else {
          nextTick(() => {
            state.CKJLRef.tobody()
          })
        }
        // tobody()
      }
      //库存查询tab
      const handleClick3 = (e) => {
        state.activeName3 = JSON.parse(JSON.stringify(e.props.name))
        if (state.activeName3 == '1') {
          nextTick(() => {
            state.YPCXRef.tobody()
          })
        } else {
          nextTick(() => {
            state.HZSYRef.tobody()
          })
        }
        // tobody()
      }
      // 获取字典
      const initData = async () => {
        state.dictList = await gitDictList([
          '332900000',
          '210000000',
          '103000000',
          '160000000',
          '116000000',
          '176000000',
          '231000000',
          '157000000',
          '158000000',
          '159000000',
          '339600000',
          '160000000',
          '113000000',
          '161000000',
          '100000000',
          '340200000',
          '339600000',
          '157000000',
          '205000000',
        ])
        state.dictList[332900000].forEach((item) => {
          item.active = false
        })
        state.listop = state.dictList[332900000]
        state.lists = JSON.parse(JSON.stringify(state.dictList[332900000]))
        // 治疗项
        state.dictList[340200000].forEach((item) => {
          item.active = false
        })
        state.doclist = state.dictList[340200000]
        state.doclists = JSON.parse(JSON.stringify(state.dictList[340200000]))
        state.RKJLRef.gettobody()
      }

      return {
        ...toRefs(state),
        handleClick,
        handleClick1,
        handleClick2,
        handleClick3,
        initData,
      }
    },
  }
</script>

<style scoped lang="scss">
  ::v-deep .el-tabs__content {
    height: calc(100% - 50px);
  }
  ::v-deep .el-tab-pane{
    height: 100%;
  }
  .tooltips {
    height: 50px;
    display: flex;
    justify-content: start;
    align-items: center;
    font-weight: 700;
    background-color: #eaf0f7 !important;
    color: #3166ae;
    text-align: left;
    line-height: 50px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .demo-form-inline {
    display: flex;
    flex-wrap: wrap;
  }

  .el-table {
    &:deep(.el-date-editor.el-input) {
      width: 98%;
    }
  }

  .tablesOne {
    margin-top: 4px;
    height: calc(100% - 60px);
    display: flex;
    justify-content: space-between;
  }

  .left {
    width: 33%;
  }

  .right {
    width: 66%;
  }

  .adviceBox {
    overflow-y: auto;
    /* height: 100%; */
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    padding: 10px;
  }

  .adviceBox1 {
    height: 100%;
  }
  .demo-tabs{
    height: 100%;
  }
  .demo-tabs>.el-tabs__content {
    padding: 32px;
    color: #6b778c;
    font-size: 32px;
    font-weight: 600;
  }

  .display_flex {
    display: flex;
    justify-content: space-between;
  }

  .search-top .w-208 {
    width: 208px;

    .searchcss {
      cursor: pointer;
    }
  }

  .faicon {
    font-size: 19px;
    margin-right: 6px;
    cursor: pointer;
  }

  .title-top {
    align-items: center;
    display: flex;
  }

  .tabclis {
    height: 32px;
    background: rgba(49, 102, 174, 0.1);
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    display: flex;
    padding: 3px;

    .tabclis_right {
      display: flex;
      padding-top: 2px;
    }
  }


  .pagination-box {
    &:deep(.el-input__inner) {
      padding-right: 15px !important;
    }
  }

  .item {
    display: flex;
    flex-wrap: wrap;
  }

  .w-144 {
    margin-top: 20px;
  }

  .stop {
    background-color: #f4a939;
  }

  .modify {
    background-color: #3166ae;
  }

  .del {
    background-color: #ffecec;
    color: #ff6b6b;
    font-weight: 700;
  }

  .top {
    height: 35px;
    margin: 8px 0;
  }
</style>

<style scoped>
  .saveRKSet {
    margin-top: 10px;
  }

  .el-input-group__append .el-select>>>.el-input__inner {
    border: none !important;
  }

  .el-form.w-144 .el-select {
    width: 100px !important;
  }

  .tables {
    height: calc(100% - 140px);
  }

  .tableSet {
    height: calc(100% - 140px);
  }

  .tables-left {
    margin-right: 10px;
    width: 30%;
  }

  .tables-right {
    margin-right: 10px;
    width: 70%;
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

  .margin-set {
    padding: 10px;
    float: right;
  }

  .form-two {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }

  .form-two .el-form-item {
    width: 48% !important;
  }

  .iconcliss {
    width: 32px;
    height: 32px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    color: #303030;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
    font-size: 18px;
    display: inline-block;
  }
</style>